<template>
	<section class="page">
		<div :style="{'height': conH +'px'}" class="con">
			<status v-if="tabIndex==0" ref="status"></status>
			<order-list v-if="tabIndex==1"></order-list>
			<mine v-if="showMine" @tapBg="closePop" />
		</div>
		<div ref="btn" class="btn tBor">
			<a @click="tabIndex=0" :class="{'btn-a1': tabIndex == 0}">Home</a>
			<a @click="changeTab(1)" :class="{'btn-a2': tabIndex == 1}">History</a>
			<a @click="changeTab(2)">My</a>
		</div>
		<service></service>
	</section>
</template>

<script>
	import orderList from './orderList'
	import status from "./status";
	import mine from "../my/mine.vue";
	import service from "@components/service";
	export default {
		data() {
			return {
				conH: '',
				tabIndex: 0,
				showMine: false,
				deviceId: ''
			}
		},
		components: {
			status,
			orderList,
			mine,
			service
		},
		
		created(){
			this.UTILS.removeParam("moneyAmount");
			this.UTILS.removeParam("exchangeId");
			this.UTILS.removeParam('periods');
			this.UTILS.removeParam('amount');
			var cToken = "";
			const cTime = this.UTILS.getParam('cTime');
			const preLoginTime = cTime && new Date(cTime).toDateString(); //前一次自动登录时间
			const curLoginTime = new Date().toDateString();
			try{
				cToken = funpera.getTokenFromApp();
				this.deviceId = funpera.getDeviceIdFromApp();
				this.UTILS.setParam('cToken', cToken);
				this.UTILS.setParam('deviceId', this.deviceId);
			}catch(e){
				cToken = this.UTILS.getParam('cToken');
			}
			if(cToken){
				if(!preLoginTime || preLoginTime !== curLoginTime){//判断是否同一天
					this.autoLogin()
				}
			}
		},
		
		mounted: function() {
			var self = this;
			self.conH = window.innerHeight - self.$refs.btn.offsetHeight;
			window.addEventListener('resize', function() {
				self.conH = window.innerHeight - self.$refs.btn.offsetHeight;
			});
		},
		methods: {
			//关闭我的
			closePop(){
				var self = this;
				self.showMine = false;
			},
			
			changeTab(val){
				const cToken = this.UTILS.getParam('cToken');
				this.UTILS.removeParam("source");
				if(cToken){
					if(val === 1){
						this.tabIndex = 1
					}
					else{
						this.showMine = true
					}
				}
				else{
					location.href = "./login.html"
				}
			},
			
			// 自动登录
			autoLogin() {
				var self = this;
				self.UTILS.axiosRequest('post', self.PATHS.loanPath + '/user/autoLogin', {
					deviceId: self.UTILS.getParam('deviceId')
				}, function(res) {
					self.UTILS.loadGif.hide();
					if (res.code == '0000') {
						if(res.data){
							self.UTILS.setParam('cToken', res.data);
							self.UTILS.setParam('cTime', new Date());
						}
						else{
							self.UTILS.removeParam('cToken');
							self.UTILS.removeParam('cTime');
						}
					} else {
						self.UTILS.removeParam('cToken');
						self.UTILS.removeParam('cTime');
						self.UTILS.logStr(res.message);
					}
				}, 1);
			}
		}
	}
</script>

<style scoped>
	@import "../../assets/css/onePx.css";

	.con {
		overflow: auto;
	}

	.btn {
		height: 0.97rem;
		line-height: 0.96rem;
		background-color: #FFF;
		position: relative;
	}

	.btn a {
		width: 33.33%;
		padding-top: 0.58rem;
		line-height: 0.3rem;
		text-align: center;
		font-size: 0.28rem;
		color: #BFBDBD;
		float: left;
	}

	.btn a:nth-child(1) {
		background: url("./img/tab1.png") no-repeat center 0.1rem;
		background-size: 0.4rem 0.44rem;
	}

	.btn a:nth-child(2) {
		background: url("./img/tab2.png") no-repeat center 0.1rem;
		background-size: 0.37rem 0.44rem;
	}
	.btn a:nth-child(3) {
		background: url("./img/tab3.png") no-repeat center 0.1rem;
		background-size: 0.4rem 0.4rem;
	}

	.btn a.btn-a1 {
		background: url("./img/selectTab1.png") no-repeat center 0.1rem;
		background-size: 0.4rem 0.44rem;
		color: #ED7D31;
	}

	.btn a.btn-a2 {
		background: url("./img/selectTab2.png") no-repeat center 0.1rem;
		background-size: 0.37rem 0.44rem;
		color: #ED7D31;
	}
</style>
